import { render, staticRenderFns } from "./FullPageDigiMentorDashboard.vue?vue&type=template&id=78fc3d5e&"
import script from "./FullPageDigiMentorDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiMentorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiMentorDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports